/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { FC, useRef, useState } from "react";
import toast from "react-hot-toast";
import checkIfValidFormat from "utils/checkIfValidFormat";
import getFileSize from "utils/getFileSize";

import { v4 as uuid } from "uuid";
interface Props {
  disabled?: boolean;
  formats?: string[];
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  maxSize?: number;
  children?: React.ReactNode;
  className?: string;
  onUpload?: (file: File) => void;
}

const HeadlessUploader: FC<Props> = ({
  disabled,
  formats = [".jpeg", ".jpg", ".png", ".pdf",".heic"],
  onChange,
  maxSize = 10,
  children,
  className,
  onUpload,
}) => {
  const [nanoId] = useState(uuid());
  const inputRef = useRef<HTMLInputElement>(null);
  
  return (
    <label htmlFor={nanoId} className={className}>
      <input
        type="file"
        ref={inputRef}
        id={nanoId}
        className="sr-only"
        disabled={disabled}
        accept={formats?.map((f) => "," + f).join("")}
        onChange={(e) => {
          if (e.target?.files?.length) {
            const file = e.target.files[0];
            const isAllowed = checkIfValidFormat(file, formats);
            if (!isAllowed) {
              if (inputRef.current) inputRef.current.value = "";
              return;
            }
            const fileSize = getFileSize(file.size);
            if (+fileSize > maxSize) {
              if (inputRef.current) inputRef.current.value = "";
              return toast.error(`File size must be less than ${maxSize}MB`);
            }
            if (onChange) {
              onChange(e);
            }
            if (onUpload) {
              onUpload(file);
            }
            if (inputRef.current) inputRef.current.value = "";
          }
        }}
      />
      {children}
    </label>
  );
};

export default HeadlessUploader;
